import { Track } from "../../shared/track/track";
import { Box, Text } from "@postenbring/hedwig-react";

export const TrackingService = ({
    ariaLabel,
    buttonLabel,
    description,
    isEnglish,
    label,
    placeholder,
    title,
    url,
}) => (
    <Box variant="lighter" className="hds-mb-20-24">
        <Text as="h2" variant="h2" className="hds-mb-20-24">
            {title}
        </Text>
        <Text as="p" className="hds-mb-20-24">
            {description}
        </Text>
        <Track
            ariaLabel={ariaLabel}
            label={label}
            buttonLabel={buttonLabel}
            isEnglish={isEnglish}
            placeholder={placeholder}
            url={url}
        />
    </Box>
);
